export type SubscriptionBannerVariant = 'none' | 'trial' | 'grace' | 'locked';

/**
 * Derives which subscription banner to show from the subscription state.
 * Precedence: locked (FR-058) > grace/restricted (FR-005a) > trial > none.
 * Ported 1:1 from the mobile app so web and mobile behave identically.
 */
export function getSubscriptionBannerVariant(state: {
  isTrialing?: boolean;
  accessStatus?: string;
}): SubscriptionBannerVariant {
  if (state.accessStatus === 'locked') return 'locked';
  if (state.accessStatus === 'restricted') return 'grace';
  if (state.isTrialing) return 'trial';
  return 'none';
}
